<template>
    <el-dialog
        width="93%"
        @close="closeDialog"
        :close-on-click-modal="false"
        class="leader-dialog"
        :visible.sync="dialogVisible"
    >
        <div v-loading="Tloading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)">
            <el-form class="leader-style-form" :inline="true">
                <!--<el-form-item label="开始时间">-->
                    <!--<el-date-picker-->
                        <!--v-model="model.time"-->
                        <!--type="date"-->
                        <!--:picker-options="pickerOptions"-->
                        <!--value-format="yyyy-MM-dd"-->
                        <!--placeholder="选择日期"-->
                    <!--&gt;</el-date-picker>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="结束时间">-->
                    <!--<el-date-picker-->
                        <!--v-model="model.to_day"-->
                        <!--type="date"-->
                        <!--:picker-options="pickerOptions"-->
                        <!--value-format="yyyy-MM-dd"-->
                        <!--placeholder="选择日期"-->
                    <!--&gt;</el-date-picker>-->
                <!--</el-form-item>-->
                <el-form-item label="时间"  >
                    <el-date-picker
                        v-model="customDateRange"
                        type="daterange"
                        :picker-options="pickerOptionsRange"
                        :clearable="false"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        format="yyyy-MM-dd"
                        >
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getHistoryPowerList">查询</el-button>
                </el-form-item>
            </el-form>
            <div style="width:100%;height: calc(80% - 1rem)">
                <el-scrollbar style="width: 100%">
                    <el-table class="leader-style-table" 
                        :data="tableJson" 
                        border 
                        style="width: 100%">
                        <el-table-column
                            v-for="item in tableHeaders"
                            :key="item.column_name"
                            :label="item.column_desc"
                            :property="item.column_name"
                            width="160"
                        ></el-table-column>
                        <!-- <el-table-column label="时间" prop="upload_time" width="160"></el-table-column>
                        <el-table-column label="A相电流" prop="a_a"></el-table-column>
                        <el-table-column label="B相电流" prop="a_b"></el-table-column>
                        <el-table-column label="C相电流" prop="a_c"></el-table-column>
                        <el-table-column label="A相电压" prop="Ua"></el-table-column>
                        <el-table-column label="B相电压" prop="Ub"></el-table-column>
                        <el-table-column label="C相电压" prop="Uc"></el-table-column>
                        <el-table-column label="A相功率" prop="p_a"></el-table-column>
                        <el-table-column label="B相功率" prop="p_b"></el-table-column>
                        <el-table-column label="C相功率" prop="p_c"></el-table-column>
                        <el-table-column label="功率" prop="P"></el-table-column>
                        <el-table-column label="A相功率因数" prop="Pfa" width="100"></el-table-column>
                        <el-table-column label="B相功率因数" prop="Pfb" width="100"></el-table-column>
                        <el-table-column label="C相功率因数" prop="Pfc" width="100"></el-table-column>
                        <el-table-column label="功率因数" prop="Pf"></el-table-column>
                        <el-table-column label="有功示数" prop="Wactive" width="100"></el-table-column>
                        <el-table-column label="无功示数" prop="Wreactive" width="100"></el-table-column> -->
                    </el-table>
                </el-scrollbar>

                <el-pagination
                    class="leader-style-pagination"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 30, 40, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                ></el-pagination>
            </div>
     
        <!-- <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" class="leader-common-button">取 消</el-button>
        </div> -->
        </div>
    </el-dialog>
</template>
<script>
    import * as api from "@/http/api.js";

    export default {
        props: {
            loading: false,
            dialogVisible: {
                type: Boolean,
                default: false
            },
            id: {
                type: String
            },
            customDateRange:[]
        },
        data() {
            return {
                Tloading: false,
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    }
                },
                pageNum: 1, //页码
                pageSize: 10, //每页条数
                currentPage: 1, //当前页码
                totalNum: 0, //总条数
                tableHeaders: [],
                tableJson: []
            };
        },
        watch: {
            dialogVisible(newVal) {
                this.getSysDate();
            }
        },
        methods: {
            // 获取系统时间
            getSysDate() {
                api.getSysDate().then(res => {
                    if (res && res.error_code === "0") {
                        let time = res.bus_json.sysdate;
                        let to_day = res.bus_json.sysdate;
                        this.customDateRange=[time,to_day];
                        this.getHistoryPowerList();
                    }
                });
            },
            // 获取历史数据
            getHistoryPowerList() {
                this.Tloading = true;
                this.tableJson = null;
                api.getWiringMeterDataList({
                    point_id: this.id,
                    // show_day: this.model.time,
                    // to_day: this.model.to_day,
                    show_day: this.customDateRange[0],
                    to_day: this.customDateRange[1],
                    pageNum: this.pageNum,
                    pageSize: this.pageSize
                }).then(res => {
                    if (res && res.error_code == 0) {
                        this.tableHeaders = res.bus_json.headList;
                        this.tableJson = res.bus_json.dataList;
                        this.tableJson.forEach(item => {
                            item.di = item.di > 0 ? "关" : "开";
                        });
                        this.totalNum = res.bus_json.count;
                    }
                    this.Tloading = false;
                });
            },
            /**
             * 列表条数改变回调
             */
            handleSizeChange(e) {
                this.pageNum = 1;
                this.pageSize = e;
                this.getHistoryPowerList();
            },
            /**
             * 企业列表页码改变回调
             */
            handleCurrentChange(e) {
                this.pageNum = e;
                this.getHistoryPowerList();
            },
            closeDialog() {
                this.dialogVisible = false;
                this.$emit("update:dialogVisible", this.dialogVisible);

            }
        }
    };
</script>
<style lang="scss">
    .el-table__empty-block {
        width: 100% !important;
    }

    // 滚动条的宽度*/
    .el-table__body-wrapper::-webkit-scrollbar {
        width: 8px;
        height: 12px;
        background: #022d79;
    }

    // 滚动条的滑块*/
    .el-table__body-wrapper::-webkit-scrollbar-thumb {
        background-color: #ddd;
        border-radius: 3px;
    }
</style>